// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2zfTf","search":"Settings_search__1Gdkw","filter":"Settings_filter__3KnEU"};